import React from "react";
import { Nav } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import {
  ProSidebarProvider,
  Sidebar,
  Menu,
  MenuItem,
  SubMenu,
} from "react-pro-sidebar";
import "./left-panel-admin.css";
import {
  AddLink,
  CertDet,
  UserDet,
  TransDet,
  MemberIcon,
  LOgOut,
  View,
  Relation_Img,
  MenuIcon,
} from "../../assets/images";
import { useHistory } from "react-router-dom";
import axios from "../../axios/axios";
import { message } from "antd";
const LeftpanelAdmin = () => {
  const navigate = useHistory();
  const confirmLogout = async () => {
    let data = { token: localStorage.getItem("AuthToken") };
    await axios
      .post("/logout", data)
      .then((res) => {
        if (res.data.status === true) {
          message.success("Logged out");
          // window.location.href='/'
          localStorage.removeItem("AuthData");
          localStorage.removeItem("AuthToken");
          navigate.push("/");
          // dispatch(setToken(""));
        } else {
          message.error("Unable to logout", 3);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
  return (
    <ProSidebarProvider>
      <Sidebar>
        <Menu>
          <div className="left_panel_partts">
            <Nav as="ul" className="ml-auto mr-auto nav_dash">
              <Nav.Item as="li">
                <NavLink exact to="/add-link">
                  <span className="dasg__imgg">
                    <img src={AddLink} alt="" />
                  </span>
                  <span>Add Link</span>
                </NavLink>
              </Nav.Item>

              <Nav.Item as="li">
                <NavLink exact to="/view-link">
                  <span className="dasg__imgg">
                    <img src={View} alt="" />
                  </span>
                  <span>View Link</span>
                </NavLink>
              </Nav.Item>
              <SubMenu label="Navigation" icon={<img src={MenuIcon} alt="" />}>
                <MenuItem href="/add-navigation"> Add Menu</MenuItem>
                <MenuItem href="/edit-navigation"> Edit Menu</MenuItem>
                <MenuItem href="/delete-navigation"> Delete Menu</MenuItem>
              </SubMenu>
              <SubMenu
                label="Certificate Details"
                icon={<img src={CertDet} alt="" />}
              >
                <MenuItem href="/certificates"> Certificates </MenuItem>
                <MenuItem href="/add-certificate"> Add Certificate </MenuItem>
                <MenuItem href="/bulk-upload"> Bulk Upload </MenuItem>
                <MenuItem href="/create-pdf"> Generate Pdf </MenuItem>
                <MenuItem href="/redeem-certificate">
                  Redeem Certificates
                </MenuItem>
                <MenuItem href="/send-certificate">Send Certificates</MenuItem>
                <MenuItem href="/limit-certificate">
                  Certificate Remainder Limit
                </MenuItem>
              </SubMenu>

              {/* <SubMenu
                label="Member Details"
                icon={<img src={MemberIcon} alt="" />}
              >
                
                <MenuItem href="/add-member"> Add Member </MenuItem>
                <MenuItem href="/bulk-upload-member"> Bulk Upload </MenuItem>
              </SubMenu> */}

              <SubMenu
                label="Escape Credits"
                icon={<img src={CertDet} alt="" />}
              >
                <MenuItem href="/add-escape-bucks-product-categories">
                  Add Product Categories
                </MenuItem>
                <MenuItem href="/add-escape-bucks-products">
                  Add Products
                </MenuItem>
                <MenuItem href="/generate-code-escape-bucks-products">
                  Code Generate
                </MenuItem>
                <MenuItem href="/escape-bucks-product-redeem-commision">
                  Escape Credits Redeem Value Rate
                </MenuItem>
                {/* <MenuItem href="/escape-tips-redeem-commission">
                  Escape Trips Redeem Commision
                </MenuItem> */}
                <MenuItem href="/escape-dollar-count">
                  Escape Credits Count
                </MenuItem>
              </SubMenu>

              <SubMenu label="Resources" icon={<img src={AddLink} alt="" />}>
                <MenuItem href="/wix-template">Wix Website Templates</MenuItem>
                <MenuItem href="/shareable-images"> Shareable Images </MenuItem>
                <MenuItem href="/certificate-guide">Certificate Guide</MenuItem>
                <MenuItem href="/faqs"> FAQs </MenuItem>
                <MenuItem href="/add-preferred-partner">
                  Add Preferred Partners
                </MenuItem>
                <MenuItem href="/preferred-partner">
                  Preferred Partners
                </MenuItem>
              </SubMenu>
              <SubMenu label="User Details" icon={<img src={UserDet} alt="" />}>
                <MenuItem href="/user-details"> Tripvalet Users </MenuItem>
                <MenuItem href="/user-details-tvi">
                  Tripvalet Incentive Users
                </MenuItem>
                <MenuItem href="/affiliate-user"> Affiliate User </MenuItem>
                {/* <MenuItem href="/tvi-corporate-user-list">
                  Tripvalet Advantage User
                </MenuItem> */}
                {/* <MenuItem href="/vip-user-list">VIP User List</MenuItem> */}
              </SubMenu>



              <SubMenu label="Corporate Advantage" icon={<img src={AddLink} alt="" />}>
                <MenuItem href="/add-corporate-client"> CA Client List </MenuItem>
                <MenuItem href="/all-corporate-member-list"> Master List of End User </MenuItem>
                <MenuItem href="/ignite-corporate-client"> Ignite Corporate Client </MenuItem>
              </SubMenu>

              {/* <Nav.Item as="li">
                <NavLink exact to="/add-corporate-client">
                  <span className="dasg__imgg">
                    <img src={AddLink} alt="" />
                  </span>
                  <span>Corporate Advantage</span>
                </NavLink>
              </Nav.Item> */}

              <Nav.Item as="li">
                <NavLink exact to="/transaction-details">
                  <span className="dasg__imgg">
                    <img src={TransDet} alt="" />
                  </span>
                  <span>Transaction Details</span>
                </NavLink>
              </Nav.Item>

              {/* <Nav.Item as="li">
                <NavLink exact to="/calendar-events">
                  <span className="dasg__imgg">
                    <img src={Calendar_Img} alt="" />
                  </span>
                  <span>Calendar of Events</span>
                </NavLink>
              </Nav.Item> */}
              {/* <Nav.Item as="li">
                <NavLink exact to="/add-affiliates">
                  <span className="dasg__imgg">
                    <img src={Relation_Img} alt="" />
                  </span>
                  <span>Add Affiliates</span>
                </NavLink> 


                
              </Nav.Item>*/}
              <SubMenu
                label="Affiliates"
                icon={<img src={Relation_Img} alt="" />}
              >
                <MenuItem href="/add-affiliates">Add Affiliates</MenuItem>
                <MenuItem href="/commission-plan">Commission Plan</MenuItem>
                <MenuItem href="/affiliate-transaction-details">
                  Transaction details
                </MenuItem>
                <MenuItem href="/affiliate-member-details">
                  Affiliate Member Details
                </MenuItem>
                <MenuItem href="/commission-report">Commission Report</MenuItem>
              </SubMenu>

              <SubMenu label="Reports" icon={<img src={MemberIcon} alt="" />}>
                {/* <MenuItem href="/reports-tvi-active-members">
                  TVI Active Members
                </MenuItem> */}
                <MenuItem href="/reports-tv-active-members">
                  TV Active Members
                </MenuItem>
                <MenuItem href="/reports-tvi-members-active-plan">
                  TVI Members Active Plan
                </MenuItem>
                <MenuItem href="/reports-tv-members-active-plan">
                  TV Members Active Plan
                </MenuItem>
                <MenuItem href="/reports-tvi-members-certificate-send">
                  Client Sent Certificate
                </MenuItem>
                <MenuItem href="/reports-tvi-members-certificate-redeemed">
                  Client Redeemed Certificate
                </MenuItem>
                <MenuItem href="/reports-client-wise-members-count">
                  Client Members Count
                </MenuItem>
                <MenuItem href="/reports-anniversary">Anniversary</MenuItem>
                <MenuItem href="/reports-active-referral">
                  Active Referral
                </MenuItem>
                <MenuItem href="/reports-subscription-canceled">
                  Subscription Canceled
                </MenuItem>
              </SubMenu>

              {/* <Nav.Item as="li">
                <NavLink exact to="/vilocity-commission-set">
                  <span className="dasg__imgg">
                    <img src={Dollar_Img} alt="" />
                  </span>
                  <span>Vilocity Commission Settings</span>
                </NavLink>
              </Nav.Item> */}

              <Nav.Item as="li">
                <NavLink exact to="#" onClick={confirmLogout}>
                  <span className="dasg__imgg">
                    <img src={LOgOut} alt="" />
                  </span>
                  <span>Log Out</span>
                </NavLink>
              </Nav.Item>
            </Nav>
          </div>
        </Menu>
      </Sidebar>
    </ProSidebarProvider>
  );
};

export default LeftpanelAdmin;
